import { HttpRestClient } from '@injectivelabs/utils';
/**
 * @hidden
 */
export default class BaseRestConsumer extends HttpRestClient {
}
